import { isInEditableRegime } from "routes/facilities/lib/when-parent-item"
import { and } from "lib/logic"
import { isEnabled } from "lib/@components/feature"
import { AssetsRegimeTab } from "routes/regime/assets/assets-regime-tab"

import { FEATURE_FLAG_ASSET_MAPPING } from "routes/asset-register/feature-flag-asset-mapping"
import { registerTab } from "lib/@components/tabs"
import { REGIME_ASSETS_TAB } from "routes/asset-register/plugins/regime-display/regime-display.runtime"

registerTab({
    tab: REGIME_ASSETS_TAB,
    id: "setup",
    title: "Asset Registers",
    predicate: and(isInEditableRegime, () => isEnabled(FEATURE_FLAG_ASSET_MAPPING)),
    content: <AssetsRegimeTab $lazy priority={170} />,
})
